import React from 'react'
import type { Theme } from '@mui/material/styles'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { createTheme } from './theme/createTheme'

export interface DesignSystemProviderProps {
  children: React.ReactNode
  /** Defaults to `createTheme()`, the PaintScout theme built from `@paintscout/util`'s palette. */
  theme?: Theme
}

const defaultTheme = createTheme()

/**
 * Wrap any tree that renders this package's components.
 *
 * `injectFirst` inserts v9's styles before v4's JSS, so v4 `makeStyles` classes can still
 * override a v9 component, the same way they override a v4 one. Apps running MUI v4 must
 * also import `@paintscout/design-system/src/setup` before anything else loads `@mui/material`.
 */
export default function DesignSystemProvider({ children, theme = defaultTheme }: DesignSystemProviderProps) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  )
}
